export enum PlanStatus {
  new = 1,
  pending = 2,
  approved = 3,
  rejected = 4,
  cancelled = 5,
  pendingEdits = 6
}
